var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 88,
    viewBox: "0 0 120 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6192 37.7276C58.2738 35.9658 61.7205 35.9658 64.3751 37.7276L113.593 70.391C120.155 74.7462 117.083 84.9988 109.215 84.9988L10.7794 84.9988C2.91157 84.9988 -0.16117 74.7463 6.40138 70.391L55.6192 37.7276Z",
    fill: "#DDFFDD",
    stroke: "#AFFFAF",
    strokeWidth: 4.04225
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9386 38.8612C65.6976 41.274 65.6976 46.73 61.9386 49.1428L12.3499 80.9726C8.24313 83.6087 2.82472 80.6843 2.82472 75.8318L2.82472 12.1722C2.82472 7.3197 8.24313 4.39534 12.3499 7.03138L61.9386 38.8612Z",
    fill: "#DDFFDD",
    stroke: "#AFFFAF",
    strokeWidth: 4.04225
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0536 38.8612C54.2946 41.274 54.2946 46.73 58.0536 49.1428L107.642 80.9726C111.749 83.6087 117.167 80.6843 117.167 75.8318L117.167 12.1722C117.167 7.3197 111.749 4.39534 107.642 7.03138L58.0536 38.8612Z",
    fill: "#DDFFDD",
    stroke: "#AFFFAF",
    strokeWidth: 4.04225
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.373 50.2724C61.7184 52.0342 58.2717 52.0342 55.6171 50.2724L6.39929 17.609C-0.163253 13.2537 2.90944 3.00118 10.7773 3.00118L109.213 3.00118C117.081 3.00119 120.153 13.2537 113.591 17.609L64.373 50.2724Z",
    fill: "#DDFFDD",
    stroke: "#AFFFAF",
    strokeWidth: 4.04225
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCode);
export default __webpack_public_path__ + "static/media/send-code.38bc1a1ade1aa5c2b33f77f207cb53c5.svg";
export { ForwardRef as ReactComponent };